import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";

export const Footer = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const isDashboard = location.pathname.startsWith("/dashboard");

  // Dashboard-safe navigation for public pages
  const handleNav = (path) => {
    // If you're logged in and currently on dashboard routes,
    // we bypass React Router and do a hard nav (new tab is safer).
    window.open(path, "_blank");
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Three-column layout: Brand + Support | Copyright | Nav Links */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr auto 1fr',
          alignItems: 'center',
          gap: '2rem'
        }}>
          {/* LEFT: Brand + Support */}
          <div>
            <div className="footer-brand" style={{ marginBottom: '0.75rem' }}>
              <div className="brand-accent">SHOWME</div>
              <div className="brand-subtitle">Campaign Finances</div>
            </div>
            <a
              href="mailto:support@showmecampaignfinances.com"
              style={{
                fontSize: '0.85rem',
                fontWeight: 500,
                color: '#2563eb',
                textDecoration: 'none'
              }}
              onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
              onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
            >
              Contact Support
            </a>
          </div>

          {/* CENTER: Copyright */}
          <div style={{
            textAlign: 'center',
            color: '#9ca3af',
            fontSize: '0.85rem',
            whiteSpace: 'nowrap'
          }}>
            © {new Date().getFullYear()} SHOWME Campaign Finances. All rights reserved.
          </div>

          {/* RIGHT: Navigation Links */}
          <div className="footer-links" style={{ justifyContent: 'flex-end' }}>
            {isAuthenticated && isDashboard ? (
              // Logged-in view (use <button> but style them like links)
              <>
                <button
                  className="footer-link-btn"
                  onClick={() => handleNav("/")}
                >
                  Home
                </button>
                <button
                  className="footer-link-btn"
                  onClick={() => handleNav("/#pricing")}
                >
                  Pricing
                </button>
                <button
                  className="footer-link-btn"
                  onClick={() => handleNav("/privacy")}
                >
                  Privacy
                </button>
                <button
                  className="footer-link-btn"
                  onClick={() => handleNav("/terms")}
                >
                  Terms
                </button>
                <button
                  className="footer-link-btn"
                  onClick={() => handleNav("/login")}
                >
                  Login
                </button>
                <button
                  className="footer-link-btn"
                  onClick={() => handleNav("/signup")}
                >
                  Sign Up
                </button>
              </>
            ) : (
              // Public / marketing view (simple Links)
              <>
                <Link to="/">Home</Link>
                <Link to="/#pricing">Pricing</Link>
                <Link to="/privacy">Privacy</Link>
                <Link to="/terms">Terms</Link>
                <Link to="/login">Login</Link>
                <Link to="/signup">Sign Up</Link>
              </>
            )}
          </div>
        </div>

        {/* Mobile: Stack on small screens */}
        <style>{`
          @media (max-width: 768px) {
            footer .footer-container > div:first-child {
              grid-template-columns: 1fr !important;
              gap: 1.5rem !important;
              text-align: center !important;
            }
            footer .footer-container > div:first-child > div {
              justify-content: center !important;
            }
            footer .footer-links {
              justify-content: center !important;
            }
          }
        `}</style>
      </div>
    </footer>
  );
};
